import React from 'react';
import { Button, useMediaQuery, useTheme } from '@mui/material';

interface LargeActionButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  marginTop?: number | string;
  marginBottom?: number | string;
  width?: number | string;
  maxWidth?: number | string;
}

const LargeActionButton = ({
  onClick,
  children,
  disabled,
  marginBottom = 2,
  marginTop = 0,
  width = '100%',
  maxWidth = 400,
}: LargeActionButtonProps) => {
  const theme = useTheme();
  const aboveSmall = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Button
      variant='contained'
      size='large'
      onClick={onClick}
      disabled={disabled}
      sx={{
        width,
        maxWidth,
        height: 60,
        borderRadius: 2,
        fontSize: aboveSmall ? '1.5rem' : '1.25rem',
        fontWeight: 'bold',
        marginTop,
        marginBottom,
        textTransform: 'none',
      }}
    >
      {children}
    </Button>
  );
};

export default LargeActionButton;
